export function ValueBreakdownWrapper({ children }: { children: React.ReactNode }) {
  return <div className="flex gap-2 flex-col mt-2 text-white">{children}</div>;
}
